/**
 * Localization strings used on Forms (don't confuse this with schema
 * localization strings)
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const formsText = createDictionary({
  forms: {
    'en-us': 'Forms',
    'ru-ru': 'Формы',
    'es-es': 'Formularios',
    'fr-fr': 'Formulaires',
    'uk-ua': 'Форми',
    'de-ch': 'Formulare',
    'pt-br': 'Formulários',
    'hr-hr': 'Obrasci',
    nb: 'Skjema',
  },
  clone: {
    'en-us': 'Clone',
    'ru-ru': 'Клон',
    'es-es': 'Clon',
    'fr-fr': 'Cloner',
    'uk-ua': 'Клон',
    'de-ch': 'Klone',
    'pt-br': 'Clone',
    'hr-hr': 'Klon',
    nb: 'Klone',
  },
  cloneDescription: {
    'en-us': 'Create a full copy of current record',
    'ru-ru': 'Создать полную копию текущей записи',
    'es-es': 'Crear una copia completa del registro actual',
    'fr-fr': "Créer une copie complète de l'enregistrement actuel",
    'uk-ua': 'Створити повну копію поточного запису',
    'de-ch': 'Erstellen einer kompletten Kopie des aktuellen Datensatzes',
    'pt-br': 'Criar uma cópia completa do registro atual',
    'hr-hr': 'Izradi potpunu kopiju trenutnog zapisa',
    nb: 'Opprett en full kopi av gjeldende post',
  },
  valueMustBeUniqueToField: {
    'en-us': 'Value must be unique to {fieldName:string}',
    'ru-ru': 'Значение должно быть уникальным для {fieldName:string}',
    'es-es': 'El valor debe ser exclusivo de {fieldName:string}',
    'fr-fr': 'La valeur doit être unique à {fieldName:string}',
    'uk-ua': 'Значення має бути унікальним для {fieldName:string}',
    'de-ch': 'Der Wert muss für {fieldName:string} eindeutig sein',
    'pt-br': 'O valor deve ser único para {fieldName:string}',
    'hr-hr': 'Vrijednost mora biti jedinstvena za {fieldName:string}',
    nb: 'Verdien må være unik for {fieldName:string}',
  },
  valueMustBeUniqueToDatabase: {
    'en-us': 'Value must be unique to database',
    'ru-ru': 'Значение должно быть уникальным для БД',
    'es-es': 'El valor debe ser exclusivo de la base de datos.',
    'fr-fr': 'La valeur doit être unique dans la base de données',
    'uk-ua': 'Значення має бути унікальним для бази даних',
    'de-ch': 'Der Wert muss innerhalb der Datenbank eindeutig sein.',
    'pt-br': 'O valor deve ser único para o banco de dados.',
    'hr-hr': 'Vrijednost mora biti jedinstvena za bazu podataka',
    nb: 'Verdien må være unik for databasen',
  },
  valuesOfMustBeUniqueToField: {
    'en-us': 'Values of {values:string} must be unique to {fieldName:string}',
    'ru-ru':
      'Значения {values:string} должны быть уникальными для {fieldName:string}',
    'es-es':
      'Los valores de {values:string} deben ser únicos para {fieldName:string}',
    'fr-fr':
      'Les valeurs de {values:string} doivent être uniques à {fieldName:string}',
    'uk-ua':
      'Значення {values:string} мають бути унікальними для {fieldName:string}',
    'de-ch':
      'Die Werte von {values:string} müssen für {fieldName:string} eindeutig sein.',
    'pt-br':
      'Os valores de {values:string} devem ser únicos para {fieldName:string}',
    'hr-hr':
      'Vrijednosti {values:string} moraju biti jedinstvene za {fieldName:string}',
    nb: 'Verdiene til {values:string} må være unike for {fieldName:string}',
  },
  valuesOfMustBeUniqueToDatabase: {
    'en-us': 'Values of {values:string} must be unique to database',
    'ru-ru':
      'Значения {values:string} должны быть уникальными для базы данных.',
    'es-es':
      'Los valores de {values:string} deben ser únicos para la base de datos.',
    'fr-fr':
      'Les valeurs de {values:string} doivent être uniques à la base de données',
    'uk-ua': 'Значення {values:string} мають бути унікальними для бази даних',
    'de-ch':
      'Die Werte von {values:string} müssen innerhalb der Datenbank eindeutig sein.',
    'pt-br':
      'Os valores de {values:string} devem ser exclusivos do banco de dados.',
    'hr-hr':
      'Vrijednosti {values:string} moraju biti jedinstvene za bazu podataka',
    nb: 'Verdiene til {values:string} må være unike for databasen',
  },
  checkingIfResourceCanBeDeleted: {
    'en-us': 'Checking if resource can be deleted…',
    'ru-ru': 'Проверка возможности удаления ресурса…',
    'es-es': 'Comprobando si el recurso se puede eliminar…',
    'fr-fr': 'Vérification de la possibilité de supprimer la ressource…',
    'uk-ua': 'Перевірка можливості видалення ресурсу…',
    'de-ch': 'Es wird geprüft, ob die Ressource gelöscht werden kann…',
    'pt-br': 'Verificando se o recurso pode ser excluído…',
    'hr-hr': 'Provjeravam može li se resurs izbrisati…',
    nb: 'Kontrollerer om ressursen kan slettes …',
  },
  checkingIfResourceIsUsed: {
    'en-us': 'Checking if this record is currently in use…',
    'de-ch': 'Es wird geprüft, ob dieser Datensatz aktuell verwendet wird…',
    'es-es': 'Comprobando si este registro está actualmente en uso…',
    'fr-fr': "Vérification de l'utilisation actuelle de cet enregistrement…",
    'pt-br': 'Verificando se este registro está em uso…',
    'ru-ru': 'Проверка, используется ли эта запись в данный момент…',
    'uk-ua': 'Перевірка, чи цей запис зараз використовується…',
    'hr-hr': 'Provjeravam je li ovaj zapis trenutno u upotrebi…',
    nb: 'Kontrollerer om denne posten er i bruk …',
  },
  noLinkedRecords: {
    'en-us': 'No linked records',
    'de-ch': 'Keine verknüpften Datensätze',
    'es-es': 'No hay registros vinculados',
    'fr-fr': 'Aucun enregistrement lié',
    'pt-br': 'Nenhum registro vinculado',
    'ru-ru': 'Нет связанных записей',
    'uk-ua': "Немає пов'язаних записів",
    'hr-hr': 'Nema povezanih zapisa',
    nb: 'Ingen lenkede poster',
  },
  recordUsedDescription: {
    'en-us': 'This resource is currently linked to the following records:',
    'de-ch': 'Diese Ressource ist derzeit mit folgenden Datensätzen verknüpft:',
    'es-es':
      'Este recurso está actualmente vinculado a los siguientes registros:',
    'fr-fr':
      'Cette ressource est actuellement liée aux enregistrements suivants :',
    'pt-br': 'Este recurso está atualmente vinculado aos seguintes registros:',
    'ru-ru': 'В настоящее время данный ресурс связан со следующими записями:',
    'uk-ua': 'Цей ресурс наразі пов’язаний з такими записами:',
    'hr-hr': 'Ovaj resurs je trenutno povezan sa sljedećim zapisima:',
    nb: 'Denne ressursen er for øyeblikket knyttet til følgende poster:',
  },
  deleteBlocked: {
    'en-us': 'Delete blocked',
    'ru-ru': 'Удалить заблокированный',
    'es-es': 'Eliminar bloqueado',
    'fr-fr': 'Suppression bloquée',
    'uk-ua': 'Видалити заблоковано',
    'de-ch': 'Löschen blockiert',
    'pt-br': 'Excluir bloqueado',
    'hr-hr': 'Izbriši blokirano',
    nb: 'Sletting blokkert',
  },
  deleteBlockedDescription: {
    'en-us':
      'The resource cannot be deleted because it is referenced by the following resources:',
    'de-ch':
      'Die Ressource kann nicht gelöscht werden, da sie von den folgenden Ressourcen referenziert wird:',
    'es-es': 'encontrar usos',
    'fr-fr':
      'La ressource ne peut pas être supprimée car les ressources suivantes y font référence :',
    'ru-ru':
      'Ресурс не может быть удален, поскольку на него ссылаются следующие ресурсы:',
    'uk-ua':
      'Ресурс не можна видалити, оскільки на нього посилаються такі ресурси:',
    'pt-br':
      'O recurso não pode ser excluído porque é referenciado pelos seguintes recursos:',
    'hr-hr':
      'Resurs se ne može izbrisati jer se na njega pozivaju sljedeći resursi:',
    nb: 'Ressursen kan ikke slettes fordi den refereres av følgende ressurser:',
  },
  relationship: {
    'en-us': 'Relationship',
    'ru-ru': 'Отношение',
    'es-es': 'Relación',
    'fr-fr': 'Relation',
    'uk-ua': 'Стосунків',
    'de-ch': 'Beziehung',
    'pt-br': 'Relação',
    'hr-hr': 'Odnos',
    nb: 'Relasjon',
  },
  paleoMap: {
    'en-us': 'Paleo Map',
    'ru-ru': 'Палеокарта',
    'es-es': 'Mapa Paleo',
    'fr-fr': 'Carte Paléo',
    'uk-ua': 'Палео-мапа',
    'de-ch': 'Paläokarte',
    'pt-br': 'Mapa Paleo',
    'hr-hr': 'Paleo karta',
    nb: 'Paleokart',
  },
  paleoRequiresGeography: {
    comment: 'Example: Geography Required',
    'en-us': '{geographyTable:string} Required',
    'ru-ru': '{geographyTable:string} Требуется',
    'es-es': '{geographyTable:string} Requerido',
    'fr-fr': '{geographyTable:string} Obligatoire',
    'uk-ua': "{geographyTable:string} Обов'язково",
    'de-ch': '{geographyTable:string} Erforderlich',
    'pt-br': '{geographyTable:string} Obrigatório',
    'hr-hr': '{geographyTable:string} Obavezno',
    nb: '{geographyTable:string} Obligatorisk',
  },
  paleoRequiresGeographyDescription: {
    'en-us':
      'The Paleo Map plugin requires that the {localityTable:string} have geographic coordinates and that the paleo context have a geographic age with at least a start time or and end time populated.',
    'de-ch':
      'Das Paleo Map-Plugin setzt voraus, dass die {localityTable:string}-Daten geografische Koordinaten besitzen und dass der Paläokontext ein geografisches Alter mit mindestens einer Start- oder Endzeit aufweist.',
    'es-es': 'Seleccionar fuente de tablas',
    'fr-fr':
      'Le plugin Paleo Map exige que les {localityTable:string} aient des coordonnées géographiques et que le contexte paléo ait un âge géographique avec un temps de début et de fin renseigné.',
    'ru-ru':
      'Для работы плагина Paleo Map необходимо, чтобы {localityTable:string} содержал географические координаты, а палеоконтекст — географический возраст, как минимум с указанием времени начала или окончания.',
    'uk-ua':
      'Плагін Paleo Map вимагає, щоб {localityTable:string} мав географічні координати, а палеодієнтний контекст мав географічний вік із зазначенням принаймні часу початку або часу завершення.',
    'pt-br':
      'O plugin Paleo Map requer que o {localityTable:string} tenha coordenadas geográficas e que o contexto paleo tenha uma idade geográfica com pelo menos um horário de início e um horário de término preenchidos.',
    'hr-hr':
      'Paleo Map dodatak zahtijeva da {localityTable:string} ima geografske koordinate i da paleo kontekst ima geografsku starost s barem popunjenim vremenom početka ili i vremenom završetka.',
    nb: 'Paleokart-programtillegget krever at tabellen {localityTable:string} har geografiske koordinater, og at paleokonteksten har en geografisk alder med minst et starttidspunkt eller et sluttidspunkt angitt.',
  },
  invalidDate: {
    'en-us': 'Invalid Date',
    'ru-ru': 'Неверная дата',
    'es-es': 'Fecha invalida',
    'fr-fr': 'Date invalide',
    'uk-ua': 'Недійсна дата',
    'de-ch': 'Ungültiges Datum',
    'pt-br': 'Data inválida',
    'hr-hr': 'Nevažeći datum',
    nb: 'Ugyldig dato',
  },
  deleteConfirmation: {
    'en-us':
      'Are you sure you want to permanently delete this {tableName:string} from the database?',
    'de-ch':
      'Sind Sie sicher, dass Sie diesen Eintrag {tableName:string} endgültig aus der Datenbank löschen möchten?',
    'es-es': 'El valor debe ser exclusivo de la base de datos.',
    'fr-fr':
      'Êtes-vous sûr de vouloir supprimer définitivement ce {tableName:string} de la base de données ?',
    'ru-ru':
      'Вы уверены, что хотите навсегда удалить этот {tableName:string} из базы данных?',
    'uk-ua':
      'Ви впевнені, що хочете остаточно видалити цей {tableName:string} з бази даних?',
    'pt-br':
      'Tem certeza de que deseja excluir permanentemente este {tableName:string} do banco de dados?',
    'hr-hr':
      'Jeste li sigurni da želite trajno izbrisati ovaj {tableName:string} iz baze podataka?',
    nb: 'Er du sikker på at du vil slette denne {tableName:string} permanent fra databasen?',
  },
  deleteConfirmationDescription: {
    'en-us': 'This action cannot be undone.',
    'ru-ru': 'Это действие необратимо.',
    'es-es': 'Esta acción no se puede deshacer.',
    'fr-fr': 'Cette action ne peut pas être annulée.',
    'uk-ua': 'Цю дію не можна скасувати.',
    'de-ch': 'Diese Handlung kann nicht rückgängig gemacht werden.',
    'pt-br': 'Esta ação não pode ser desfeita.',
    'hr-hr': 'Ova se radnja ne može poništiti.',
    nb: 'Denne handlingen kan ikke angres.',
  },
  datePrecision: {
    'en-us': 'Date Precision',
    'ru-ru': 'Точность даты',
    'es-es': 'Precisión de fecha',
    'fr-fr': 'Précision de la date',
    'uk-ua': 'Точність дати',
    'de-ch': 'Datumsgenauigkeit',
    'pt-br': 'Precisão da data',
    'hr-hr': 'Preciznost datuma',
    nb: 'Datopresisjon',
  },
  monthYear: {
    comment: `
      A placeholder for partial date field when "month /year" type is selected.
      Visible only in browsers that don\'t support the "month" input type.
    `,
    'en-us': 'Mon / Year',
    'ru-ru': 'Пн / Год',
    'es-es': 'Usar configuraciones personalizadas',
    'fr-fr': 'Mois / Année',
    'uk-ua': 'Пн / Рік',
    'de-ch': 'Monat / Jahr',
    'pt-br': 'Segunda-feira / Ano',
    'hr-hr': 'Pon / God.',
    nb: 'Mnd / år',
  },
  yearPlaceholder: {
    comment:
      'A placeholder for partial date field when "year" type is selected',
    'en-us': 'YYYY',
    'ru-ru': 'ГГГГГ',
    'es-es': 'AAAA',
    'fr-fr': 'AAAA',
    'uk-ua': 'РРРР',
    'de-ch': 'YYYY',
    'pt-br': 'YYYY',
    'hr-hr': 'GGGG',
    nb: 'ÅÅÅÅ',
  },
  today: {
    'en-us': 'Today',
    'ru-ru': 'Сегодня',
    'es-es': 'Hoy',
    'fr-fr': "Aujourd'hui",
    'uk-ua': 'Сьогодні',
    'de-ch': 'Heute',
    'pt-br': 'Hoje',
    'hr-hr': 'Danas',
    nb: 'I dag',
  },
  todayButtonDescription: {
    'en-us': 'Set to current date',
    'ru-ru': 'Установлено на текущую дату',
    'es-es': 'Establecer a la fecha actual',
    'fr-fr': 'Définir sur la date actuelle',
    'uk-ua': 'Встановити на поточну дату',
    'de-ch': 'Auf aktuelles Datum einstellen',
    'pt-br': 'Definir para a data atual',
    'hr-hr': 'Postavi na trenutni datum',
    nb: 'Bruk dagens dato',
  },
  addToPickListConfirmation: {
    'en-us': 'Add to {pickListTable:string}?',
    'ru-ru': 'Добавить в {pickListTable:string}?',
    'es-es': '¿Añadir a {pickListTable:string}?',
    'fr-fr': 'Ajouter à {pickListTable:string} ?',
    'uk-ua': 'Додати до {pickListTable:string}?',
    'de-ch': 'Zu {pickListTable:string} hinzufügen?',
    'pt-br': 'Adicionar ao {pickListTable:string}?',
    'hr-hr': 'Dodati u {pickListTable:string}?',
    nb: 'Legge til i {pickListTable:string}?',
  },
  addToPickListConfirmationDescription: {
    'en-us':
      'Add value "{value:string}" to the {pickListTable:string} named "{pickListName:string}"?',
    'de-ch':
      'Den Wert "{value:string}" zum {pickListTable:string} mit dem Namen "{pickListName:string}" hinzufügen?',
    'es-es':
      '¿Añadir el valor "{value:string}" al {pickListTable:string} llamado "{pickListName:string}"?',
    'fr-fr':
      'Ajouter la valeur « {value:string} » au {pickListTable:string} nommé « {pickListName:string} » ?',
    'ru-ru':
      'Добавить значение "{value:string}" к {pickListTable:string} с именем "{pickListName:string}"?',
    'uk-ua':
      'Додати значення "{value:string}" до {pickListTable:string} з назвою "{pickListName:string}"?',
    'pt-br':
      'Adicionar o valor "{value:string}" ao {pickListTable:string} nomeado "{pickListName:string}"?',
    'hr-hr':
      'Dodati vrijednost "{value:string}" u {pickListTable:string} pod nazivom "{pickListName:string}"?',
    nb: 'Legge til verdien «{value:string}» til {pickListTable:string} med navnet «{pickListName:string}»?',
  },
  invalidType: {
    'en-us': 'Invalid Type',
    'ru-ru': 'Недопустимый тип',
    'es-es': 'Tipo inválido',
    'fr-fr': 'Type invalide',
    'uk-ua': 'Недійсний тип',
    'de-ch': 'Ungültiger Datentyp',
    'pt-br': 'Tipo inválido',
    'hr-hr': 'Nevažeća vrsta',
    nb: 'Ugyldig type',
  },
  invalidNumericPicklistValue: {
    'en-us': 'Only numeric values are supported in this {pickListTable:string}',
    'de-ch':
      'In diesem {pickListTable:string} werden nur numerische Werte unterstützt.',
    'es-es': 'Solo se admiten valores numéricos en este {pickListTable:string}',
    'fr-fr':
      'Seules les valeurs numériques sont prises en charge dans ce {pickListTable:string}',
    'ru-ru':
      'В этом {pickListTable:string} поддерживаются только числовые значения.',
    'uk-ua':
      'У цьому {pickListTable:string} підтримуються лише числові значення',
    'pt-br':
      'Somente valores numéricos são suportados neste {pickListTable:string}',
    'hr-hr':
      'U ovom {pickListTable:string} su podržane samo numeričke vrijednosti',
    nb: 'Bare numeriske verdier støttes i denne {pickListTable:string}',
  },
  noData: {
    'en-us': 'No Data.',
    'ru-ru': 'Нет данных.',
    'es-es': 'Sin datos.',
    'fr-fr': 'Aucune donnée.',
    'uk-ua': 'Немає даних.',
    'de-ch': 'Keine Daten.',
    'pt-br': 'Sem dados.',
    'hr-hr': 'Nema podataka.',
    nb: 'Ingen data.',
  },
  recordSetDeletionWarning: {
    'en-us':
      'The {recordSetTable:string} "{recordSetName:string}" will be deleted. The referenced records will NOT be deleted from the database.',
    'ru-ru':
      '{recordSetTable:string} "{recordSetName:string}" будет удалено. Указанные записи НЕ будут удалены из базы данных.',
    'es-es':
      'El {recordSetTable:string} "{recordSetName:string}" será eliminado. Los registros referenciados NO serán eliminados de la base de datos.',
    'fr-fr':
      'Le {recordSetTable:string} « {recordSetName:string} » sera supprimé. Les enregistrements référencés ne seront PAS supprimés de la base de données.',
    'uk-ua':
      '{recordSetTable:string} "{recordSetName:string}" буде видалено. Записи, на які посилаються, НЕ будуть видалені з бази даних.',
    'de-ch':
      'Die Einträge {recordSetTable:string} "{recordSetName:string}" werden gelöscht. Die referenzierten Datensätze werden NICHT aus der Datenbank gelöscht.',
    'pt-br':
      'O {recordSetTable:string} "{recordSetName:string}" será excluído. Os registros referenciados NÃO serão excluídos do banco de dados.',
    'hr-hr':
      '{recordSetTable:string} "{recordSetName:string}" bit će izbrisan. Referencirani zapisi NEĆE biti izbrisani iz baze podataka.',
    nb: '{recordSetTable:string} «{recordSetName:string}» vil bli slettet. De refererte postene vil IKKE bli slettet fra databasen.',
  },
  saveRecordFirst: {
    'en-us': 'Save record first',
    'ru-ru': 'Сначала сохраните запись.',
    'es-es': 'Primero guarda el registro',
    'fr-fr': "Sauvegarder d'abord l'enregistrement",
    'uk-ua': 'Спочатку збережіть запис',
    'de-ch': 'Datensatz zuerst speichern',
    'pt-br': 'Salvar registro primeiro',
    'hr-hr': 'Prvo spremi zapis',
    nb: 'Lagre posten først',
  },
  firstRecord: {
    'en-us': 'First Record',
    'ru-ru': 'Первая запись',
    'es-es': 'Primer récord',
    'fr-fr': 'Premier enregistrement',
    'uk-ua': 'Перший запис',
    'de-ch': 'Erster Rekord',
    'pt-br': 'Primeiro registro',
    'hr-hr': 'Prvi zapis',
    nb: 'Første plate',
  },
  lastRecord: {
    'en-us': 'Last Record',
    'ru-ru': 'Последняя запись',
    'es-es': 'Último registro',
    'fr-fr': 'Dernier enregistrement',
    'uk-ua': 'Останній запис',
    'de-ch': 'Letzter Datensatz',
    'pt-br': 'Último registro',
    'hr-hr': 'Posljednji zapis',
    nb: 'Siste post',
  },
  previousRecord: {
    'en-us': 'Previous Record',
    'ru-ru': 'Предыдущая запись',
    'es-es': 'Registro anterior',
    'fr-fr': 'Enregistrement précédent',
    'uk-ua': 'Попередній запис',
    'de-ch': 'Vorheriger Datensatz',
    'pt-br': 'Registro anterior',
    'hr-hr': 'Prethodni zapis',
    nb: 'Forrige post',
  },
  nextRecord: {
    'en-us': 'Next Record',
    'ru-ru': 'Следующая запись',
    'es-es': 'Siguiente récord',
    'fr-fr': 'Enregistrement suivant',
    'uk-ua': 'Наступний запис',
    'de-ch': 'Nächster Datensatz',
    'pt-br': 'Próximo registro',
    'hr-hr': 'Sljedeći zapis',
    nb: 'Neste opptak',
  },
  currentRecord: {
    'en-us': 'Current object (out of {total:number|formatted})',
    'ru-ru': 'Текущий объект (из {total:number|formatted})',
    'es-es': 'Objeto actual (de {total:number|formatted})',
    'fr-fr': 'Objet actuel (sur {total:number|formatted})',
    'uk-ua': "Поточний об'єкт (з {total:number|formatted})",
    'de-ch': 'Aktuelles Objekt (von {total:number|formatted})',
    'pt-br': 'Objeto atual (de {total:number|formatted})',
    'hr-hr': 'Trenutni objekt (izvan {total:number|formatted})',
    nb: 'Gjeldende objekt (av {total:number|formatted})',
  },
  unsavedFormUnloadProtect: {
    'en-us': 'This form has not been saved.',
    'ru-ru': 'Эта форма не сохранена.',
    'es-es': 'Este formulario no se ha guardado.',
    'fr-fr': "Ce formulaire n'a pas été enregistré.",
    'uk-ua': 'Цю форму не збережено.',
    'de-ch': 'Dieses Formular wurde nicht gespeichert.',
    'pt-br': 'Este formulário não foi salvo.',
    'hr-hr': 'Ovaj obrazac nije spremljen.',
    nb: 'Dette skjemaet er ikke lagret.',
  },
  saveConflict: {
    comment: 'Meaning a conflict occurred when saving',
    'en-us': 'Save conflict',
    'ru-ru': 'Сохранить конфликт',
    'es-es': 'Salvar el conflicto',
    'fr-fr': 'Sauver le conflit',
    'uk-ua': 'Зберегти конфлікт',
    'de-ch': 'Konflikt speichern',
    'pt-br': 'Salvar conflito',
    'hr-hr': 'Spremi sukob',
    nb: 'Lagre konflikt',
  },
  saveConflictDescription: {
    'en-us':
      'The data shown on this page has been changed by another user or in another browser tab and is out of date. The page must be reloaded to prevent inconsistent data from being saved.',
    'ru-ru':
      'Данные, отображаемые на этой странице, были изменены другим пользователем или в другой вкладке браузера и устарели. Для предотвращения сохранения несогласованных данных необходимо перезагрузить страницу.',
    'es-es':
      'Los datos que se muestran en esta página han sido modificados por otro usuario o en otra pestaña del navegador y están desactualizados. Es necesario recargar la página para evitar que se guarden datos inconsistentes.',
    'fr-fr':
      "Les données affichées sur cette page ont été modifiées par un autre utilisateur ou dans un autre onglet du navigateur et sont obsolètes. La page doit être rechargée pour éviter l'enregistrement de données incohérentes.",
    'uk-ua':
      'Дані, що відображаються на цій сторінці, були змінені іншим користувачем або в іншій вкладці браузера та застарілі. Сторінку необхідно перезавантажити, щоб запобігти збереженню невідповідних даних.',
    'de-ch':
      'Die auf dieser Seite angezeigten Daten wurden von einem anderen Benutzer oder in einem anderen Browsertab geändert und sind daher veraltet. Die Seite muss neu geladen werden, um zu verhindern, dass inkonsistente Daten gespeichert werden.',
    'pt-br':
      'Os dados exibidos nesta página foram alterados por outro usuário ou em outra aba do navegador e estão desatualizados. A página precisa ser recarregada para evitar que dados inconsistentes sejam salvos.',
    'hr-hr':
      'Podaci prikazani na ovoj stranici promijenio je drugi korisnik ili su promijenjeni na drugoj kartici preglednika te su zastarjeli. Stranicu je potrebno ponovno učitati kako bi se spriječilo spremanje nedosljednih podataka.',
    nb: 'Dataene som vises på denne siden er endret av en annen bruker eller i en annen nettleserfane, og er utdaterte. Siden må lastes inn på nytt for å forhindre at inkonsistente data lagres.',
  },
  saveBlocked: {
    'en-us': 'Save blocked',
    'de-ch': 'Speichern blockiert',
    'es-es': 'Guardar bloqueado',
    'fr-fr': 'Enregistrement bloqué',
    'ru-ru': 'Сохранение заблокировано',
    'uk-ua': 'Зберегти заблоковано',
    'pt-br': 'Salvar bloqueado',
    'hr-hr': 'Spremi blokirano',
    nb: 'Lagre blokkert',
  },
  saveBlockedDescription: {
    'en-us': 'Form cannot be saved because of the following error:',
    'ru-ru': 'Сохранение формы невозможно из-за следующей ошибки:',
    'es-es': 'El formulario no se puede guardar debido al siguiente error:',
    'fr-fr':
      "Le formulaire ne peut pas être enregistré en raison de l'erreur suivante :",
    'uk-ua': 'Форму неможливо зберегти через таку помилку:',
    'de-ch':
      'Das Formular konnte aufgrund des folgenden Fehlers nicht gespeichert werden:',
    'pt-br': 'O formulário não pôde ser salvo devido ao seguinte erro:',
    'hr-hr': 'Obrazac se ne može spremiti zbog sljedeće greške:',
    nb: 'Skjemaet kan ikke lagres på grunn av følgende feil:',
  },
  unavailableCommandButton: {
    'en-us': 'Command N/A',
    'ru-ru': 'Команда недоступна',
    'es-es': 'Comando N/A',
    'fr-fr': 'Commande N/A',
    'uk-ua': 'Команда Немає',
    'de-ch': 'Befehl N/A',
    'pt-br': 'Comando N/A',
    'hr-hr': 'Naredba N/A',
    nb: 'Kommando Ikke aktuelt',
  },
  commandUnavailable: {
    'en-us': 'Command Not Available',
    'ru-ru': 'Команда недоступна',
    'es-es': 'Comando no disponible',
    'fr-fr': 'Commande non disponible',
    'uk-ua': 'Команда недоступна',
    'de-ch': 'Befehl nicht verfügbar',
    'pt-br': 'Comando não disponível',
    'hr-hr': 'Naredba nije dostupna',
    nb: 'Kommando ikke tilgjengelig',
  },
  commandUnavailableDescription: {
    'en-us': 'This command is currently unavailable for Specify 7.',
    'ru-ru':
      'В настоящее время эта команда недоступна для параметра Specify 7.',
    'es-es': 'Este comando no está disponible actualmente para Specify 7.',
    'uk-ua': 'Ця команда наразі недоступна для Specify 7.',
    'de-ch': 'Dieser Befehl ist für Specify 7 derzeit nicht verfügbar.',
    'fr-fr': "Cette commande n'est actuellement pas disponible pour Specify 7.",
    'pt-br': 'Este comando está atualmente indisponível para o Specify 7.',
    'hr-hr': 'Ova naredba trenutno nije dostupna za Specify 7.',
    nb: 'Denne kommandoen er for øyeblikket ikke tilgjengelig for Specifice 7.',
  },
  commandUnavailableSecondDescription: {
    'en-us':
      'It was probably included on this form from Specify 6 and may be supported in the future.',
    'ru-ru':
      'Вероятно, эта функция была включена в данную форму из раздела «Указания 6» и может быть добавлена в будущем.',
    'es-es':
      'Probablemente se incluyó en este formulario de la Especificación 6 y es posible que se admita en el futuro.',
    'fr-fr':
      "Il était probablement déjà inclus dans ce formulaire dans de Specify 6 et pourrait être pris en charge à l'avenir.",
    'uk-ua':
      'Ймовірно, це було включено до цієї форми з Specify 6 і може бути підтримано в майбутньому.',
    'de-ch':
      'Es wurde wahrscheinlich in dieser Version von Specify 6 übernommen und wird möglicherweise auch in Zukunft unterstützt.',
    'pt-br':
      'Provavelmente foi incluído neste formulário a partir da versão 6 do Specify e poderá ser suportado no futuro.',
    'hr-hr':
      'Vjerojatno je uključeno u ovaj obrazac iz Specify 6 i možda će biti podržano u budućnosti.',
    nb: 'Det var sannsynligvis inkludert på dette skjemaet fra Spesifiser 6 og kan bli støttet i fremtiden.',
  },
  commandName: {
    'en-us': 'Command name',
    'ru-ru': 'Название команды',
    'es-es': 'Nombre del comando',
    'fr-fr': 'Nom de la commande',
    'uk-ua': 'Назва команди',
    'de-ch': 'Befehlsname',
    'pt-br': 'Nome do comando',
    'hr-hr': 'Naziv naredbe',
    nb: 'Kommandonavn',
  },
  unavailablePluginButton: {
    'en-us': 'Plugin N/A',
    'ru-ru': 'Плагин недоступен',
    'es-es': 'Complemento N/A',
    'fr-fr': 'Plugin N/A',
    'uk-ua': 'Плагін Немає',
    'de-ch': 'Plugin nicht verfügbar',
    'pt-br': 'Plugin N/A',
    'hr-hr': 'Dodatak N/A',
    nb: 'Programtillegg ikke tilgjengelig',
  },
  pluginNotAvailable: {
    'en-us': 'Plugin Not Available',
    'ru-ru': 'Плагин недоступен',
    'es-es': 'Complemento no disponible',
    'fr-fr': 'Plugin non disponible',
    'uk-ua': 'Плагін недоступний',
    'de-ch': 'Plugin nicht verfügbar',
    'pt-br': 'Plugin não disponível',
    'hr-hr': 'Dodatak nije dostupan',
    nb: 'Plugin ikke tilgjengelig',
  },
  pluginNotAvailableDescription: {
    'en-us': 'This plugin is currently unavailable for Specify 7',
    'ru-ru': 'Этот плагин в настоящее время недоступен для Specify 7.',
    'es-es': 'Este complemento no está disponible actualmente para Specify 7',
    'fr-fr': "Ce plugin n'est actuellement pas disponible pour Specify 7",
    'uk-ua': 'Цей плагін наразі недоступний для Specify 7',
    'de-ch': 'Dieses Plugin ist derzeit für Specify 7 nicht verfügbar.',
    'pt-br': 'Este plugin está atualmente indisponível para o Specify 7.',
    'hr-hr': 'Ovaj dodatak trenutno nije dostupan za Specify 7',
    nb: 'Denne pluginen er for øyeblikket ikke tilgjengelig for Specifice 7',
  },
  wrongTableForPlugin: {
    comment:
      'Example: ... Locality, Collecting Event or Collection Object forms.',
    'en-us':
      'This plugin cannot be used on the {currentTable:string} form. Try moving it to the {supportedTables:string} forms.',
    'ru-ru':
      'Этот плагин нельзя использовать в форме {currentTable:string}. Попробуйте переместить его в формы {supportedTables:string}.',
    'es-es':
      'Este complemento no se puede utilizar en el formulario {currentTable:string}. Intente moverlo a los formularios {supportedTables:string}.',
    'fr-fr':
      'Ce plugin ne peut pas être utilisé dans le formulaire {currentTable:string}. Essayez de le déplacer vers les formulaires {supportedTables:string}.',
    'uk-ua':
      'Цей плагін не можна використовувати на формі {currentTable:string}. Спробуйте перемістити його на форми {supportedTables:string}.',
    'de-ch':
      'Dieses Plugin kann nicht für das {currentTable:string}-Formular verwendet werden. Versuchen Sie, es in das {supportedTables:string}-Formular zu verschieben.',
    'pt-br':
      'Este plugin não pode ser usado no formulário {currentTable:string}. Tente movê-lo para os formulários {supportedTables:string}.',
    'hr-hr':
      'Ovaj dodatak se ne može koristiti na obrascu {currentTable:string}. Pokušajte ga premjestiti na obrasce {supportedTables:string}.',
    nb: 'Denne plugin-modulen kan ikke brukes på {currentTable:string}-skjemaet. Prøv å flytte den til {supportedTables:string}-skjemaene.',
  },
  wrongTableForCommand: {
    'en-us':
      'The command cannot be used on the {currentTable:string} form. It can only be used on the {correctTable:string} form.',
    'ru-ru':
      'Данная команда не может быть использована в форме {currentTable:string}. Она может быть использована только в форме {correctTable:string}.',
    'es-es':
      'El comando no se puede utilizar en el formulario {currentTable:string}. Sólo se puede utilizar en el formulario {correctTable:string}.',
    'fr-fr':
      'La commande ne peut pas être utilisée dans le formulaire {currentTable:string}. Elle ne peut être utilisée que dans le formulaire {correctTable:string}.',
    'uk-ua':
      'Команду не можна використовувати у формі {currentTable:string}. Її можна використовувати лише у формі {correctTable:string}.',
    'de-ch':
      'Der Befehl kann nicht im Formular {currentTable:string} verwendet werden. Er kann nur im Formular {correctTable:string} verwendet werden.',
    'pt-br':
      'O comando não pode ser usado no formulário {currentTable:string}. Ele só pode ser usado no formulário {correctTable:string}.',
    'hr-hr':
      'Naredba se ne može koristiti na obrascu {currentTable:string}. Može se koristiti samo na obrascu {correctTable:string}.',
    nb: 'Kommandoen kan ikke brukes på {currentTable:string}-skjemaet. Den kan bare brukes på {correctTable:string}-skjemaet.',
  },
  pluginName: {
    'en-us': 'Plugin name',
    'ru-ru': 'Название плагина',
    'es-es': 'Nombre del complemento',
    'fr-fr': 'Nom du plugin',
    'uk-ua': 'Назва плагіна',
    'de-ch': 'Plugin-Name',
    'pt-br': 'Nome do plugin',
    'hr-hr': 'Naziv dodatka',
    nb: 'Plugin-navn',
  },
  illegalBool: {
    comment: `
      Yes/No probably shouldn't be translated as Specify 7 does not support
      changing which values are recognized as Yes/No in a given language
    `,
    'en-us': 'Illegal value for a Yes/No field',
    'ru-ru': 'Недопустимое значение для поля "Да/Нет"',
    'es-es': 'Valor ilegal para un campo Sí/No',
    'fr-fr': 'Valeur interdite pour un champ Oui/Non',
    'uk-ua': 'Неприпустиме значення для поля «Так/Ні»',
    'de-ch': 'Ungültiger Wert für ein Ja/Nein-Feld',
    'pt-br': 'Valor inválido para um campo Sim/Não',
    'hr-hr': 'Nedozvoljena vrijednost za polje Da/Ne',
    nb: 'Ugyldig verdi for et Ja/Nei-felt',
  },
  requiredField: {
    'en-us': 'Field is required.',
    'ru-ru': 'Поле обязательно для заполнения.',
    'es-es': 'Se requiere campo.',
    'fr-fr': 'Ce champ est obligatoire.',
    'uk-ua': "Поле обов'язкове для заповнення.",
    'de-ch': 'Dieses Feld ist erforderlich.',
    'pt-br': 'Campo obrigatório.',
    'hr-hr': 'Polje je obavezno.',
    nb: 'Felt er obligatorisk.',
  },
  invalidValue: {
    'en-us': 'Invalid value',
    'ru-ru': 'Недопустимое значение',
    'es-es': 'Hoy',
    'fr-fr': 'Valeur invalide',
    'uk-ua': 'Недійсне значення',
    'de-ch': 'Ungültiger Wert',
    'pt-br': 'Valor inválido',
    'hr-hr': 'Nevažeća vrijednost',
    nb: 'Ugyldig verdi',
  },
  requiredFormat: {
    comment: 'Used in field validation messages on the form',
    'en-us': 'Required Format: {format:string}.',
    'ru-ru': 'Требуемый формат: {format:string}.',
    'es-es': 'Formato requerido: {format:string}.',
    'fr-fr': 'Format requis : {format:string}.',
    'uk-ua': 'Необхідний формат: {format:string}.',
    'de-ch': 'Erforderliches Format: {format:string}.',
    'pt-br': 'Formato necessário: {format:string}.',
    'hr-hr': 'Potreban format: {format:string}.',
    nb: 'Nødvendig format: {format:string}.',
  },
  inputTypeNumber: {
    'en-us': 'Value must be a number',
    'ru-ru': 'Значение должно быть числом.',
    'es-es': 'El valor debe ser un número.',
    'uk-ua': 'Значення має бути числом',
    'de-ch': 'Der Wert muss eine Zahl sein.',
    'fr-fr': 'La valeur doit être un nombre',
    'pt-br': 'O valor deve ser um número.',
    'hr-hr': 'Vrijednost mora biti broj',
    nb: 'Verdien må være et tall',
  },
  organization: {
    'en-us': 'Organization',
    'ru-ru': 'Организация',
    'es-es': 'Organización',
    'fr-fr': 'Organisation',
    'uk-ua': 'Організація',
    'de-ch': 'Organisation',
    'pt-br': 'Organização',
    'hr-hr': 'Organizacija',
    nb: 'Organisasjon',
  },
  person: {
    'en-us': 'Person',
    'ru-ru': 'Человек',
    'es-es': 'Persona',
    'fr-fr': 'Personne',
    'uk-ua': 'Людина',
    'de-ch': 'Person',
    'pt-br': 'Pessoa',
    'hr-hr': 'Osoba',
    nb: 'Person',
  },
  other: {
    'en-us': 'Other',
    'ru-ru': 'Другой',
    'es-es': 'Otro',
    'fr-fr': 'Autre',
    'uk-ua': 'Інше',
    'de-ch': 'Andere',
    'pt-br': 'Outro',
    'hr-hr': 'Ostalo',
    nb: 'Annen',
  },
  group: {
    'en-us': 'Group',
    'ru-ru': 'Группа',
    'es-es': 'Grupo',
    'fr-fr': 'Groupe',
    'uk-ua': 'Група',
    'de-ch': 'Gruppe',
    'pt-br': 'Grupo',
    'hr-hr': 'Skupina',
    nb: 'Gruppe',
  },
  userDefinedItems: {
    'en-us': 'User Defined Items',
    'ru-ru': 'Элементы, определяемые пользователем',
    'es-es': 'Elementos definidos por el usuario',
    'fr-fr': "Éléments définis par l'utilisateur",
    'uk-ua': 'Елементи, визначені користувачем',
    'de-ch': 'Benutzerdefinierte Elemente',
    'pt-br': 'Itens definidos pelo usuário',
    'hr-hr': 'Korisnički definirane stavke',
    nb: 'Brukerdefinerte elementer',
  },
  entireTable: {
    'en-us': 'Entire Table',
    'ru-ru': 'Вся таблица',
    'es-es': 'Tabla entera',
    'fr-fr': 'Table entière',
    'uk-ua': 'Вся таблиця',
    'de-ch': 'Gesamte Tabelle',
    'pt-br': 'Mesa inteira',
    'hr-hr': 'Cijela tablica',
    nb: 'Hele bordet',
  },
  fieldFromTable: {
    'en-us': 'Field From Table',
    'ru-ru': 'Поле из таблицы',
    'es-es': 'Campo de la tabla',
    'fr-fr': 'Champ de la table',
    'uk-ua': 'Поле з таблиці',
    'de-ch': 'Feld aus Tabelle',
    'pt-br': 'Campo da tabela',
    'hr-hr': 'Polje iz tablice',
    nb: 'Felt fra tabell',
  },
  unsupportedCellType: {
    'en-us': 'Unsupported cell type',
    'ru-ru': 'Неподдерживаемый тип ячейки',
    'es-es': 'Tipo de celda no compatible',
    'fr-fr': 'Type de cellule non pris en charge',
    'uk-ua': 'Непідтримуваний тип клітинки',
    'de-ch': 'Nicht unterstützter Zelltyp',
    'pt-br': 'Tipo de célula não suportado',
    'hr-hr': 'Nepodržana vrsta ćelije',
    nb: 'Ustøttet celletype',
  },
  additionalResultsOmitted: {
    comment: `
      Represents truncated search dialog output (when lots of results returned)
    `,
    'en-us': 'Additional results omitted',
    'ru-ru': 'Дополнительные результаты опущены',
    'es-es': 'Resultados adicionales omitidos',
    'fr-fr': 'Résultats supplémentaires masqués',
    'uk-ua': 'Додаткові результати пропущені',
    'de-ch': 'Weitere Ergebnisse wurden ausgelassen.',
    'pt-br': 'Resultados adicionais omitidos',
    'hr-hr': 'Dodatni rezultati izostavljeni',
    nb: 'Ytterligere resultater utelatt',
  },
  recordSelectorUnloadProtect: {
    'en-us': 'Proceed without saving?',
    'ru-ru': 'Продолжить без сохранения?',
    'es-es': '¿Continuar sin guardar?',
    'fr-fr': 'Continuer sans enregistrer ?',
    'uk-ua': 'Продовжити без збереження?',
    'de-ch': 'Fortfahren ohne Speichern?',
    'pt-br': 'Prosseguir sem salvar?',
    'hr-hr': 'Nastaviti bez spremanja?',
    nb: 'Fortsette uten å lagre?',
  },
  recordSelectorUnloadProtectDescription: {
    comment: `
      When in record set and current record is unsaved and try to navigate to
      another record
    `,
    'en-us': 'You might want to save this record before navigating away.',
    'ru-ru':
      'Возможно, вам стоит сохранить эту запись, прежде чем покинуть страницу.',
    'es-es':
      'Quizás quieras guardar este registro antes de salir de la página.',
    'fr-fr':
      'Vous voudrez peut-être sauvegarder cet enregistrement avant de quitter la page.',
    'uk-ua':
      'Можливо, ви захочете зберегти цей запис, перш ніж залишати сторінку.',
    'de-ch':
      'Sie sollten diesen Eintrag speichern, bevor Sie die Seite verlassen.',
    'pt-br': 'Você pode querer salvar este registro antes de sair.',
    'hr-hr':
      'Možda biste željeli spremiti ovaj zapis prije nego što napustite stranicu.',
    nb: 'Du bør kanskje lagre denne oppføringen før du navigerer videre.',
  },
  creatingNewRecord: {
    'en-us': 'Creating new record',
    'ru-ru': 'Создание новой записи',
    'es-es': 'Creando un nuevo registro',
    'fr-fr': "Création d'un nouvel enregistrement",
    'uk-ua': 'Створення нового запису',
    'de-ch': 'Neuen Datensatz erstellen',
    'pt-br': 'Criando novo registro',
    'hr-hr': 'Izrada novog zapisa',
    nb: 'Oppretter ny post',
  },
  createNewRecordSet: {
    'en-us': 'Create a new record set',
    'ru-ru': 'Создать новый набор записей',
    'es-es': 'Crear un nuevo conjunto de registros',
    'fr-fr': "Créer un nouvel ensemble d'enregistrements",
    'uk-ua': 'Створити новий набір записів',
    'de-ch': 'Erstellen Sie einen neuen Datensatz',
    'pt-br': 'Criar um novo conjunto de registros',
    'hr-hr': 'Izradi novi skup zapisa',
    nb: 'Opprett et nytt postsett',
  },
  forward: {
    'en-us': 'Forward',
    'ru-ru': 'Вперед',
    'es-es': 'Adelante',
    'fr-fr': 'Avant',
    'uk-ua': 'Вперед',
    'de-ch': 'Nach vorne',
    'pt-br': 'Avançar',
    'hr-hr': 'Naprijed',
    nb: 'Framover',
  },
  reverse: {
    'en-us': 'Reverse',
    'ru-ru': 'Обеспечить регресс',
    'es-es': 'Contrarrestar',
    'fr-fr': 'Arrière',
    'uk-ua': 'Зворотний',
    'de-ch': 'Umkehren',
    'pt-br': 'Reverter',
    'hr-hr': 'Obrnuto',
    nb: 'Omvendt',
  },
  deletedInline: {
    'en-us': '(deleted)',
    'ru-ru': '(удалено)',
    'es-es': '(eliminado)',
    'fr-fr': '(supprimé)',
    'uk-ua': '(видалено)',
    'de-ch': '(gelöscht)',
    'pt-br': '(excluído)',
    'hr-hr': '(izbrisano)',
    nb: '(slettet)',
  },
  duplicateRecordSetItem: {
    comment: 'Example: Duplicate Record Set Item',
    'en-us': 'Duplicate {recordSetItemTable:string}',
    'ru-ru': 'Дубликат {recordSetItemTable:string}',
    'es-es': 'Duplicar {recordSetItemTable:string}',
    'uk-ua': 'Дублікат {recordSetItemTable:string}',
    'de-ch': 'Duplikat {recordSetItemTable:string}',
    'fr-fr': 'Dupliquer {recordSetItemTable:string}',
    'pt-br': 'Duplicado {recordSetItemTable:string}',
    'hr-hr': 'Duplikat {recordSetItemTable:string}',
    nb: 'Duplikat {recordSetItemTable:string}',
  },
  duplicateRecordSetItemDescription: {
    'en-us':
      'This record is already present in the current {recordSetTable:string}',
    'ru-ru': 'Эта запись уже присутствует в текущем {recordSetTable:string}',
    'es-es':
      'Este registro ya está presente en el {recordSetTable:string} actual.',
    'fr-fr':
      'Cet enregistrement est déjà présent dans le {recordSetTable:string} actuel',
    'uk-ua': 'Цей запис вже присутній у поточному {recordSetTable:string}',
    'de-ch':
      'Dieser Datensatz ist bereits im aktuellen {recordSetTable:string} vorhanden.',
    'pt-br': 'Este registro já está presente no {recordSetTable:string} atual.',
    'hr-hr': 'Ovaj zapis je već prisutan u trenutnom {recordSetTable:string}',
    nb: 'Denne oppføringen finnes allerede i gjeldende {recordSetTable:string}',
  },
  addToRecordSet: {
    'en-us': 'Add to {recordSetTable:string}',
    'ru-ru': 'Добавить в {recordSetTable:string}',
    'es-es': 'Agregar a {recordSetTable:string}',
    'fr-fr': 'Ajouter à {recordSetTable:string}',
    'uk-ua': 'Додати до {recordSetTable:string}',
    'de-ch': 'Zu {recordSetTable:string} hinzufügen',
    'pt-br': 'Adicionar ao {recordSetTable:string}',
    'hr-hr': 'Dodaj u {recordSetTable:string}',
    nb: 'Legg til i {recordSetTable:string}',
  },
  removeFromRecordSet: {
    'en-us': 'Remove from {recordSetTable:string}',
    'ru-ru': 'Удалить из {recordSetTable:string}',
    'es-es': 'Eliminar de {recordSetTable:string}',
    'fr-fr': 'Retirer de {recordSetTable:string}',
    'uk-ua': 'Видалити з {recordSetTable:string}',
    'de-ch': 'Aus {recordSetTable:string} entfernen',
    'pt-br': 'Remover de {recordSetTable:string}',
    'hr-hr': 'Ukloni iz {recordSetTable:string}',
    nb: 'Fjern fra {recordSetTable:string}',
  },
  nothingFound: {
    'en-us': 'Nothing found',
    'ru-ru': 'Ничего не найдено',
    'es-es': 'No se encontró nada',
    'fr-fr': "Rien n'a été trouvé",
    'uk-ua': 'Нічого не знайдено',
    'de-ch': 'Nichts gefunden',
    'pt-br': 'Nada encontrado',
    'hr-hr': 'Ništa nije pronađeno',
    nb: 'Ingenting funnet',
  },
  carryForward: {
    comment: 'Verb. Button label',
    'en-us': 'Carry Forward',
    'ru-ru': 'Перенести на следующий день',
    'es-es': 'Llevar adelante',
    'fr-fr': 'Reporter',
    'uk-ua': 'Перенести далі',
    'de-ch': 'Übertragen',
    'pt-br': 'Levar adiante',
    'hr-hr': 'Prenesi dalje',
    nb: 'Fortsett',
  },
  carryForwardEnabled: {
    'en-us': 'Show Carry Forward button',
    'ru-ru': 'Показать кнопку "Перенести"',
    'es-es': 'Mostrar botón de arrastre',
    'fr-fr': 'Afficher le bouton Reporter',
    'uk-ua': 'Показати кнопку «Перенести вперед»',
    'de-ch': 'Schaltfläche „Übertrag anzeigen“',
    'pt-br': 'Mostrar botão de transferência',
    'hr-hr': 'Prikaži gumb za prijenos naprijed',
    nb: 'Vis knappen for videreføring',
  },
  bulkCarryForwardEnabled: {
    'en-us': 'Show Bulk Carry Forward count',
    'de-ch': 'Anzahl der Massenüberträge anzeigen',
    'es-es': 'Mostrar recuento de arrastre masivo',
    'fr-fr': 'Afficher le nombre de reports en masse',
    'pt-br': 'Mostrar contagem de transferência em massa',
    'ru-ru': 'Показать количество перенесенных пакетов данных',
    'uk-ua': 'Показати кількість групового перенесення',
    'hr-hr': 'Prikaži broj skupnog prijenosa naprijed',
    nb: 'Vis antall masseoverføringer',
  },
  bulkCarryForwardCount: {
    'en-us': 'Bulk Carry Forward count',
    'de-ch': 'Zählung der Massenüberträge',
    'es-es': 'Recuento de arrastre masivo',
    'fr-fr': 'Nombre de report en masse',
    'pt-br': 'Contagem de transferência em massa',
    'ru-ru': 'Перенос данных на будущие периоды',
    'uk-ua': 'Кількість перенесених даних',
    'hr-hr': 'Broj skupnog prijenosa naprijed',
    nb: 'Antall masseoverføringer',
  },
  carryForwardDescription: {
    'en-us': 'Create a new record with certain fields carried over',
    'ru-ru': 'Создать новую запись с перенесенными определенными полями.',
    'es-es': 'Cree un nuevo registro con ciertos campos transferidos.',
    'fr-fr': 'Créer un nouvel enregistrement avec certains champs reportés',
    'uk-ua': 'Створити новий запис із перенесенням певних полів',
    'de-ch':
      'Erstellen Sie einen neuen Datensatz, bei dem bestimmte Felder übernommen werden.',
    'pt-br': 'Crie um novo registro com determinados campos transferidos.',
    'hr-hr': 'Stvorite novi zapis s prenesenim određenim poljima',
    nb: 'Opprett en ny post med bestemte felt overført',
  },
  carryForwardSettingsDescription: {
    'en-us': 'Configure fields to carry forward',
    'ru-ru': 'Настройте поля для переноса.',
    'es-es': 'Configurar los campos que se transferirán',
    'fr-fr': 'Configurer les champs à reporter',
    'uk-ua': 'Налаштуйте поля для перенесення',
    'de-ch': 'Konfigurieren Sie die Felder, die übertragen werden sollen',
    'pt-br': 'Configure os campos a serem transferidos para a próxima etapa.',
    'hr-hr': 'Konfigurirajte polja za prijenos naprijed',
    nb: 'Konfigurer felt for videreføring',
  },
  bulkCarryForwardSettingsDescription: {
    'en-us': 'Configure fields to bulk carry forward',
    'de-ch': 'Felder für den Massenübertrag konfigurieren',
    'es-es': 'Configure los campos para transferir masivamente.',
    'fr-fr': 'Configurer les champs pour un report en masse',
    'pt-br': 'Configure os campos para transferência em massa.',
    'ru-ru': 'Настройте поля для массового переноса.',
    'uk-ua': 'Налаштуйте поля для масового перенесення',
    'hr-hr': 'Konfigurirajte polja za skupni prijenos naprijed',
    nb: 'Konfigurer felt for masseoverføring fremover',
  },
  carryForwardTableSettingsDescription: {
    'en-us': 'Configure fields to carry forward ({tableName:string})',
    'ru-ru': 'Настройте поля для переноса ({tableName:string})',
    'es-es': 'Configurar campos para transferir ({tableName:string})',
    'fr-fr': 'Configurer les champs à reporter ({tableName:string})',
    'uk-ua': 'Налаштуйте поля для перенесення ({tableName:string})',
    'de-ch':
      'Felder konfigurieren, die übertragen werden sollen ({tableName:string})',
    'pt-br': 'Configurar campos para serem transferidos ({tableName:string})',
    'hr-hr': 'Konfiguriraj polja za prijenos ({tableName:string})',
    nb: 'Konfigurer felt for overføring fremover ({tableName:string})',
  },
  bulkCarryForwardTableSettingsDescription: {
    'en-us': 'Configure fields to bulk carry forward ({tableName:string})',
    'de-ch': 'Felder für den Massenübertrag konfigurieren ({tableName:string})',
    'es-es':
      'Configurar campos para transferir masivamente ({tableName:string})',
    'fr-fr':
      'Configurer les champs pour un report en masse ({tableName:string})',
    'pt-br':
      'Configurar campos para transferência em massa ({tableName:string})',
    'ru-ru': 'Настройка полей для массового переноса ({tableName:string})',
    'uk-ua': 'Налаштуйте поля для масового перенесення ({tableName:string})',
    'hr-hr': 'Konfigurirajte polja za skupni prijenos ({tableName:string})',
    nb: 'Konfigurer felt for masseoverføring fremover ({tableName:string})',
  },
  carryForwardUniqueField: {
    'en-us': 'This field must be unique. It can not be carried over',
    'ru-ru':
      'Это поле должно быть уникальным. Оно не может быть перенесено из одного места в другое.',
    'es-es': 'Este campo debe ser único. No se puede transferir.',
    'fr-fr': 'Ce champ doit être unique. Il ne peut pas être reporté.',
    'uk-ua': 'Це поле має бути унікальним. Його не можна переносити',
    'de-ch':
      'Dieses Feld muss eindeutig sein. Es kann nicht übertragen werden.',
    'pt-br': 'Este campo deve ser único. Não pode ser repetido.',
    'hr-hr': 'Ovo polje mora biti jedinstveno. Ne može se prenijeti.',
    nb: 'Dette feltet må være unikt. Det kan ikke overføres',
  },
  carryForwardRequiredField: {
    'en-us': 'This field is required. It must be carried forward',
    'ru-ru': 'Это поле обязательно для заполнения. Оно должно быть сохранено.',
    'es-es': 'Este campo es obligatorio. Debe ser transferido',
    'fr-fr': 'Ce champ est obligatoire. Il doit être reporté',
    'uk-ua': "Це поле обов'язкове. Його потрібно перенести",
    'de-ch': 'Dieses Feld ist erforderlich. Es muss übertragen werden',
    'pt-br': 'Este campo é obrigatório. Ele deve ser mantido.',
    'hr-hr': 'Ovo polje je obavezno. Mora se prenijeti dalje.',
    nb: 'Dette feltet er obligatorisk. Det må overføres.',
  },
  bulkCarryForwardRangeEnabled: {
    'en-us': 'Show Bulk Carry Forward range',
    'de-ch': 'Bereich für Massenüberträge anzeigen',
    'es-es': 'Mostrar rango de arrastre de volumen',
    'fr-fr': 'Afficher la plage de report en masse',
    'pt-br': 'Mostrar intervalo de transferência de peso',
    'ru-ru': 'Показать диапазон переноса оптовых заказов',
    'uk-ua': 'Показати діапазон масового перенесення',
    'hr-hr': 'Prikaži raspon skupnog prijenosa naprijed',
    nb: 'Vis rekkevidde for masseoverføring',
  },
  bulkCarryForwardRangeErrorDescription: {
    'en-us':
      'Cannot carry forward record through the specified {field:string} range.',
    'de-ch':
      'Der Datensatz kann nicht über den angegebenen Bereich {field:string} hinaus fortgeführt werden.',
    'es-es':
      'No se puede transferir el registro a través del rango {field:string} especificado.',
    'fr-fr':
      "Impossible de reporter l'enregistrement sur la plage {field:string} spécifiée.",
    'pt-br':
      'Não é possível prosseguir com o registro através do intervalo especificado {field:string}.',
    'ru-ru':
      'Невозможно перенести запись через указанный диапазон {field:string}.',
    'uk-ua': 'Неможливо перенести запис у вказаний діапазон {field:string}.',
    'hr-hr':
      'Nije moguće prenijeti zapis naprijed kroz navedeni raspon {field:string}.',
    nb: 'Kan ikke overføre posten fremover gjennom det angitte {field:string}-området.',
  },
  bulkCarryForwardRangeLimitExceeded: {
    'en-us': 'Range exceeds record limit of {limit:number}.',
    'de-ch': 'Der Bereich überschreitet den Rekordwert von {limit:number}.',
    'es-es': 'El rango supera el límite de registro de {limit:number}.',
    'fr-fr': "La plage dépasse la limite d'enregistrement de {limit:number}.",
    'pt-br': 'O alcance excede o limite de registro de {limit:number}.',
    'ru-ru': 'Диапазон превышает рекордный предел {limit:number}.',
    'uk-ua': 'Діапазон перевищує ліміт записів {limit:number}.',
    'hr-hr': 'Raspon premašuje ograničenje zapisa od {limit:number}.',
    nb: 'Rekkevidden overskrider opptaksgrensen på {limit:number}.',
  },
  bulkCarryForwardRangeExistingRecords: {
    'en-us': 'The following numbers for {field:string} are already being used:',
    'de-ch': 'Folgende Nummern für {field:string} werden bereits verwendet:',
    'es-es': 'Los siguientes números para {field:string} ya están en uso:',
    'fr-fr': 'Les numéros suivants pour {field:string} sont déjà utilisés :',
    'pt-br': 'Os seguintes números para {field:string} já estão sendo usados:',
    'ru-ru': 'Следующие номера для {field:string} уже используются:',
    'uk-ua': 'Наступні номери для {field:string} вже використовуються:',
    'hr-hr': 'Sljedeći brojevi za {field:string} se već koriste:',
    nb: 'Følgende tall for {field:string} er allerede i bruk:',
  },
  bulkCarryForwardRangeStart: {
    'en-us': 'Carry Forward Range Start',
    'de-ch': 'Vorwärtsbewegung Reichweite Start',
    'es-es': 'Arrastre hacia adelante Inicio de rango',
    'fr-fr': 'Début de la plage de report',
    'pt-br': 'Início do intervalo de transferência',
    'ru-ru': 'Начало диапазона переноса',
    'uk-ua': 'Початок діапазону перенесення вперед',
    'hr-hr': 'Početak raspona prijenosa naprijed',
    nb: 'Start av fremdriftsrekkevidde',
  },
  bulkCarryForwardRangeEnd: {
    'en-us': 'Carry Forward Range End',
    'de-ch': 'Reichweitenende für Weitertragen',
    'es-es': 'Fin del rango de arrastre',
    'fr-fr': 'Fin de la plage de report',
    'pt-br': 'Fim do intervalo de transporte',
    'ru-ru': 'Конец диапазона переноса',
    'uk-ua': 'Кінець діапазону перенесення вперед',
    'hr-hr': 'Kraj raspona prijenosa naprijed',
    nb: 'End of Carry Forward Range',
  },
  createRecordSetOnBulkCarryForward: {
    'en-us': 'Create record set on Bulk Carry Forward',
    'de-ch': 'Datensatz für Massenübertrag erstellen',
    'es-es': 'Crear conjunto de registros en Carga masiva',
    'fr-fr': "Créer un ensemble d'enregistrements sur le report en masse",
    'pt-br': 'Criar conjunto de registros em Transferência em Massa',
    'ru-ru': 'Создание набора записей в рамках функции массового переноса.',
    'uk-ua': 'Створення набору записів для групового перенесення',
    'hr-hr': 'Stvori skup zapisa pri skupnom prijenosu naprijed',
    nb: 'Opprett postsett på masseoverføring',
  },
  cloneButtonEnabled: {
    'en-us': 'Show Clone button',
    'ru-ru': 'Показать кнопку «Клон»',
    'es-es': 'Mostrar botón Clonar',
    'fr-fr': 'Afficher le bouton Cloner',
    'uk-ua': 'Кнопка «Показати клон»',
    'de-ch': 'Schaltfläche „Klonen anzeigen“',
    'pt-br': 'Mostrar botão Clonar',
    'hr-hr': 'Prikaži gumb Kloniraj',
    nb: 'Vis klone-knapp',
  },
  addButtonEnabled: {
    'en-us': 'Show Add button',
    'ru-ru': 'Показать кнопку «Добавить»',
    'es-es': 'Mostrar botón Agregar',
    'fr-fr': 'Afficher le bouton Ajouter',
    'uk-ua': 'Показати кнопку «Додати»',
    'de-ch': 'Schaltfläche "Hinzufügen" anzeigen',
    'pt-br': 'Mostrar botão Adicionar',
    'hr-hr': 'Prikaži gumb Dodaj',
    nb: 'Vis Legg til-knappen',
  },
  addButtonDescription: {
    'en-us': 'Create a new blank record',
    'ru-ru': 'Создать новую пустую запись',
    'es-es': 'Crear un nuevo registro en blanco',
    'fr-fr': 'Créer un nouvel enregistrement vierge',
    'uk-ua': 'Створити новий пустий запис',
    'de-ch': 'Einen neuen leeren Datensatz erstellen',
    'pt-br': 'Criar um novo registro em branco',
    'hr-hr': 'Stvori novi prazan zapis',
    nb: 'Opprett en ny, tom post',
  },
  autoNumbering: {
    'en-us': 'Auto Numbering',
    'ru-ru': 'Автоматическая нумерация',
    'es-es': 'Numeración automática',
    'fr-fr': 'Numérotation automatique',
    'uk-ua': 'Автоматична нумерація',
    'de-ch': 'Automatische Nummerierung',
    'pt-br': 'Numeração automática',
    'hr-hr': 'Automatsko numeriranje',
    nb: 'Automatisk nummerering',
  },
  autoNumberByYear: {
    'en-us': 'Auto-number by year',
    'de-ch': 'Auto-Nummer nach Jahr',
    'es-es': 'Auto-número por año',
    'fr-fr': 'Auto-numéro par année',
    'ru-ru': 'Автонумерация по году',
    'uk-ua': 'Автонумерація за роком',
    'pt-br': 'Numeração automática por ano',
    'hr-hr': 'Automatsko numeriranje po godini',
    nb: 'Automatisk nummerering etter år',
  },
  autoNumber: {
    'en-us': 'Auto-number',
    'de-ch': 'Auto-Nummer',
    'es-es': 'Auto-número',
    'fr-fr': 'Auto-numéro',
    'ru-ru': 'Автонумерация',
    'uk-ua': 'Автонумерація',
    'pt-br': 'Número automático',
    'hr-hr': 'Automatsko numeriranje',
    nb: 'Automatisk nummerering',
  },
  editFormDefinition: {
    'en-us': 'Edit Form Definition',
    'ru-ru': 'Редактировать определение формы',
    'es-es': 'Definición del formulario de edición',
    'fr-fr': 'Modifier la définition du formulaire',
    'uk-ua': 'Редагувати визначення форми',
    'de-ch': 'Definition des Bearbeitungsformulars',
    'pt-br': 'Editar definição de formulário',
    'hr-hr': 'Uredi definiciju obrasca',
    nb: 'Rediger skjemadefinisjon',
  },
  useAutoGeneratedForm: {
    'en-us': 'Use Auto Generated Form',
    'ru-ru': 'Используйте автоматически сгенерированную форму',
    'es-es': 'Utilice el formulario generado automáticamente.',
    'fr-fr': 'Utiliser le formulaire généré automatiquement',
    'uk-ua': 'Використати автоматично згенеровану форму',
    'de-ch': 'Automatisch generiertes Formular verwenden',
    'pt-br': 'Usar formulário gerado automaticamente',
    'hr-hr': 'Koristi automatski generirani obrazac',
    nb: 'Bruk automatisk generert skjema',
  },
  useFieldLabels: {
    'en-us': 'Use Localized Field Labels',
    'ru-ru': 'Используйте локализованные метки полей.',
    'es-es': 'Utilice etiquetas de campo localizadas',
    'fr-fr': 'Utiliser les étiquettes de champs localisées',
    'uk-ua': 'Використовуйте локалізовані мітки полів',
    'de-ch': 'Lokalisierte Feldbezeichnungen verwenden',
    'pt-br': 'Usar rótulos de campo localizados',
    'hr-hr': 'Koristite lokalizirane oznake polja',
    nb: 'Bruk lokaliserte feltetiketter',
  },
  showFieldLabels: {
    'en-us': 'Show Localized Field Labels',
    'de-ch': 'Lokalisierte Feldbezeichnungen anzeigen',
    'es-es': 'Mostrar etiquetas de campo localizadas',
    'fr-fr': 'Afficher les étiquettes de champ localisées',
    'ru-ru': 'Отображение локализованных меток полей',
    'uk-ua': 'Показати локалізовані підписи полів',
    'pt-br': 'Exibir rótulos de campo localizados',
    'hr-hr': 'Prikaži lokalizirane oznake polja',
    nb: 'Vis lokaliserte feltetiketter',
  },
  showDataModelLabels: {
    'en-us': 'Show Data Model Field Names',
    'de-ch': 'Datenmodellfeldnamen anzeigen',
    'es-es': 'Mostrar nombres de campos del modelo de datos',
    'fr-fr': 'Afficher les noms des champs du modèle de données',
    'ru-ru': 'Отображение названий полей модели данных',
    'uk-ua': 'Показати назви полів моделі даних',
    'pt-br': 'Exibir nomes de campos do modelo de dados',
    'hr-hr': 'Prikaži nazive polja modela podataka',
    nb: 'Vis feltnavn for datamodeller',
  },
  editHistory: {
    'en-us': 'Edit history',
    'ru-ru': 'Редактировать историю',
    'es-es': 'Historial de ediciones',
    'fr-fr': "Modifier l'historique",
    'uk-ua': 'Історія редагування',
    'de-ch': 'Bearbeitungsgeschichte',
    'pt-br': 'Editar histórico',
    'hr-hr': 'Povijest uređivanja',
    nb: 'Rediger historikk',
  },
  editHistoryQueryName: {
    'en-us': 'Edit history for "{formattedRecord:string}"',
    'ru-ru': 'История изменений для "{formattedRecord:string}"',
    'es-es': 'Historial de ediciones de "{formattedRecord:string}"',
    'fr-fr': "Modifier l'historique pour « {formattedRecord:string} »",
    'uk-ua': 'Історія редагувань для "{formattedRecord:string}"',
    'de-ch': 'Bearbeitungsverlauf für „{formattedRecord:string}“',
    'pt-br': 'Histórico de edições para "{formattedRecord:string}"',
    'hr-hr': 'Povijest uređivanja za "{formattedRecord:string}"',
    nb: 'Rediger historikk for «{formattedRecord:string}»',
  },
  formConfiguration: {
    'en-us': 'Form Configuration',
    'ru-ru': 'Настройка формы',
    'es-es': 'Configuración del formulario',
    'fr-fr': 'Configuration du formulaire',
    'uk-ua': 'Конфігурація форми',
    'de-ch': 'Formularkonfiguration',
    'pt-br': 'Configuração do formulário',
    'hr-hr': 'Konfiguracija obrasca',
    nb: 'Skjemakonfigurasjon',
  },
  formState: {
    'en-us': 'Form State',
    'ru-ru': 'Форма государства',
    'es-es': 'Formulario Estado',
    'fr-fr': 'État du formulaire',
    'uk-ua': 'Стан форми',
    'de-ch': 'Form State',
    'pt-br': 'Estado do Formulário',
    'hr-hr': 'Stanje obrasca',
    nb: 'Skjemastatus',
  },
  recordInformation: {
    'en-us': 'Record Information',
    'ru-ru': 'Запись информации',
    'es-es': 'Información del registro',
    'fr-fr': 'Informations sur les enregistrements',
    'uk-ua': 'Інформація про запис',
    'de-ch': 'Datensatzinformationen',
    'pt-br': 'Informações do registro',
    'hr-hr': 'Podaci o zapisu',
    nb: 'Opptaksinformasjon',
  },
  shareRecord: {
    'en-us': 'Share Record',
    'ru-ru': 'Поделиться записью',
    'es-es': 'Compartir registro',
    'fr-fr': "Partager l'enregistrement",
    'uk-ua': 'Поділитися записом',
    'de-ch': 'Anteilsaufzeichnung',
    'pt-br': 'Compartilhar registro',
    'hr-hr': 'Podijeli zapis',
    nb: 'Del post',
  },
  findUsages: {
    'en-us': 'Find usages',
    'ru-ru': 'Найти примеры использования',
    'es-es': 'Encuentra usos',
    'fr-fr': 'Trouver des utilisations',
    'uk-ua': 'Знайти вживання',
    'de-ch': 'Anwendungsbeispiele finden',
    'pt-br': 'Encontre usos',
    'hr-hr': 'Pronađi upotrebe',
    nb: 'Finn bruksområder',
  },
  usagesOfPickList: {
    'en-us': 'Usages of "{pickList:string}" pick list',
    'ru-ru': 'Использование выпадающего списка "{pickList:string}"',
    'es-es': 'Usos de la lista desplegable "{pickList:string}"',
    'fr-fr': 'Utilisations de la liste de sélection « {pickList:string} »',
    'uk-ua': 'Використання списку вибору "{pickList:string}"',
    'de-ch': 'Verwendungsmöglichkeiten der Auswahlliste "{pickList:string}"',
    'pt-br': 'Usos da lista de seleção "{pickList:string}"',
    'hr-hr': 'Upotreba popisa za odabir "{pickList:string}"',
    nb: 'Bruk av valglisten «{pickList:string}»',
  },
  subForm: {
    'en-us': 'Subform',
    'ru-ru': 'Подформа',
    'es-es': 'Subform',
    'fr-fr': 'Sous-formulaire',
    'uk-ua': 'Підформа',
    'de-ch': 'Unterformular',
    'pt-br': 'Subform',
    'hr-hr': 'Podobrazac',
    nb: 'Delskjema',
  },
  formTable: {
    'en-us': 'Grid',
    'ru-ru': 'Сетка',
    'es-es': 'Red',
    'fr-fr': 'Grille',
    'uk-ua': 'Сітка',
    'de-ch': 'Netz',
    'pt-br': 'Grade',
    'hr-hr': 'Mreža',
    nb: 'Rutenett',
  },
  subviewConfiguration: {
    'en-us': 'Subview',
    'ru-ru': 'Дополнительный просмотр',
    'es-es': 'Subvista',
    'uk-ua': 'Підвид',
    'de-ch': 'Unteransicht',
    'fr-fr': 'Sous-vue',
    'pt-br': 'Subvista',
    'hr-hr': 'Podprikaz',
    nb: 'Delvisning',
  },
  disableReadOnly: {
    'en-us': 'Disable read-only mode',
    'ru-ru': 'Отключить режим только для чтения',
    'es-es': 'Deshabilitar el modo de solo lectura',
    'fr-fr': 'Désactiver le mode lecture seule',
    'uk-ua': 'Вимкнути режим лише для читання',
    'de-ch': 'Schreibgeschützten Modus deaktivieren',
    'pt-br': 'Desativar o modo somente leitura',
    'hr-hr': 'Onemogući način rada samo za čitanje',
    nb: 'Deaktiver skrivebeskyttet modus',
  },
  enableReadOnly: {
    'en-us': 'Enable read-only mode',
    'ru-ru': 'Включить режим только для чтения',
    'es-es': 'Habilitar el modo de solo lectura',
    'fr-fr': 'Activer le mode lecture seule',
    'uk-ua': 'Увімкнути режим лише для читання',
    'de-ch': 'Nur-Lese-Modus aktivieren',
    'pt-br': 'Ativar modo somente leitura',
    'hr-hr': 'Omogući način samo za čitanje',
    nb: 'Aktiver skrivebeskyttet modus',
  },
  configureDataEntryTables: {
    'en-us': 'Configure data entry tables',
    'ru-ru': 'Настройка таблиц ввода данных',
    'es-es': 'Configurar tablas de entrada de datos',
    'fr-fr': 'Configurer les tables de saisie de données',
    'uk-ua': 'Налаштування таблиць для введення даних',
    'de-ch': 'Dateneingabetabellen konfigurieren',
    'pt-br': 'Configurar tabelas de entrada de dados',
    'hr-hr': 'Konfigurirajte tablice za unos podataka',
    nb: 'Konfigurer datainntastingstabeller',
  },
  configureInteractionTables: {
    'en-us': 'Configure interaction tables',
    'ru-ru': 'Настройка таблиц взаимодействия',
    'es-es': 'Configurar tablas de interacción',
    'fr-fr': "Configurer les tables d'interaction",
    'uk-ua': 'Налаштування таблиць взаємодії',
    'de-ch': 'Interaktionstabellen konfigurieren',
    'pt-br': 'Configurar tabelas de interação',
    'hr-hr': 'Konfigurirajte tablice interakcije',
    nb: 'Konfigurer interaksjonstabeller',
  },
  formMeta: {
    'en-us': 'Form Meta',
    'ru-ru': 'Форма Мета',
    'es-es': 'Formulario Meta',
    'fr-fr': 'Formulaire Meta',
    'uk-ua': 'Метадані форми',
    'de-ch': 'Formular Meta',
    'pt-br': 'Formulário Meta',
    'hr-hr': 'Meta obrazaca',
    nb: 'Skjemameta',
  },
  newResourceTitle: {
    'en-us': 'New {tableName:string}',
    'ru-ru': 'Новый {tableName:string}',
    'es-es': 'Nuevo {tableName:string}',
    'fr-fr': 'Nouveau {tableName:string}',
    'uk-ua': 'Новий {tableName:string}',
    'de-ch': 'Neu {tableName:string}',
    'pt-br': 'Novo {tableName:string}',
    'hr-hr': 'Novo {tableName:string}',
    nb: 'Ny {tableName:string}',
  },
  resourceFormatter: {
    comment: `
      When resource does not have a formatter defined, this formatter is used
    `,
    'en-us': '{tableName:string} #{id:number}',
    'ru-ru': '{tableName:string} #{id:number}',
    'es-es': '{tableName:string} #{id:number}',
    'fr-fr': '{tableName:string} #{id:number}',
    'uk-ua': "{tableName:string} '#{id:number}",
    'de-ch': '{tableName:string} #{id:number}',
    'pt-br': '{tableName:string} #{id:number}',
    'hr-hr': '{tableName:string} #{id:number}',
    nb: '{tableName:string} #{id:number}',
  },
  resourceDeleted: {
    'en-us': 'Resource deleted',
    'ru-ru': 'Ресурс удален',
    'es-es': 'Recurso eliminado',
    'fr-fr': 'Ressource supprimée',
    'uk-ua': 'Ресурс видалено',
    'de-ch': 'Ressource gelöscht',
    'pt-br': 'Recurso excluído',
    'hr-hr': 'Resurs izbrisan',
    nb: 'Ressurs slettet',
  },
  resourceDeletedDescription: {
    'en-us': 'Item was deleted successfully.',
    'ru-ru': 'Элемент успешно удалён.',
    'es-es': 'El elemento se eliminó correctamente.',
    'fr-fr': "L'élément a été supprimé avec succès.",
    'uk-ua': 'Елемент успішно видалено.',
    'de-ch': 'Der Artikel wurde erfolgreich gelöscht.',
    'pt-br': 'O item foi excluído com sucesso.',
    'hr-hr': 'Stavka je uspješno izbrisana.',
    nb: 'Elementet ble slettet.',
  },
  dateRange: {
    'en-us': '(Range: {from:string} - {to:string})',
    'ru-ru': '(Диапазон: {from:string} - {to:string})',
    'es-es': '(Rango: {from:string} - {to:string})',
    'fr-fr': '(Plage : {from:string} - {to:string})',
    'uk-ua': '(Діапазон: {from:string} - {to:string})',
    'de-ch': '(Bereich: {from:string} - {to:string})',
    'pt-br': '(Intervalo: {from:string} - {to:string})',
    'hr-hr': '(Raspon: {from:string} - {to:string})',
    nb: '(Område: {from:string}–{to:string})',
  },
  catalogNumberNumericFormatter: {
    comment: 'Meaning "Catalog Number Numeric formatter"',
    'en-us': 'Catalog Number Numeric',
    'de-ch': 'Katalognummer (numerisch)',
    'es-es': 'Número de catálogo numérico',
    'fr-fr': 'Numéro de catalogue numérique',
    'ru-ru': 'Каталожный номер (числовой)',
    'uk-ua': 'Номер у каталозі (числовий)',
    'pt-br': 'Número de catálogo numérico',
    'hr-hr': 'Broj kataloga Numerički',
    nb: 'Katalognummer Numerisk',
  },
  addCOGChildren: {
    'en-us': 'Add COG Children',
    'de-ch': 'COG-Kinder hinzufügen',
    'es-es': 'Agregar niños COG',
    'fr-fr': 'Ajouter des enfants COG',
    'pt-br': 'Adicionar COG Children',
    'ru-ru': 'Добавить детей COG',
    'uk-ua': 'Додати дочірні елементи COG',
    'hr-hr': 'Dodajte djecu COG-a',
    nb: 'Legg til COG-underordnede',
  },
} as const);
